import { render, staticRenderFns } from "./PageFirst.vue?vue&type=template&id=3118e54b&scoped=true"
import script from "./PageFirst.vue?vue&type=script&lang=js"
export * from "./PageFirst.vue?vue&type=script&lang=js"
import style0 from "./PageFirst.vue?vue&type=style&index=0&id=3118e54b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3118e54b",
  null
  
)

export default component.exports